import React, { useEffect, useState, useMemo } from "react";
import CommanTable from "../../components/table/CommanTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addNewRoleData,
  editRoleData,
  getRolesData,
  deleteRolesData,
  getRoleUsersById,
} from "../../redux/slices/userRoleSlice";
import {
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  setLimit,
  setPage,
  setSelectedOption,
} from "../../redux/slices/globalSlice";
import Confirmation from "../../components/dialog/Confirmation";
import RoleDeleteConfirmation from "../../components/dialog/RoleDeleteConfirmation";
import {
  setActionName,
  setCloseBtnName,
  setIsActivatePopup,
  setIsEditActive,
  setIsEditpopup,
  setIsPopUpShow,
  setPopUpTitle,
  setSubmitBtnName,
} from "../../redux/slices/popUpSlice";
import { Button, Form, Input, message, Modal, Table } from "antd";
import ActiveDeactive from "../../components/dialog/ActivateDeactivate";
import { getAllPermissions } from "../../redux/slices/userManagementSlice";
import { isUserRoleDelete } from "../../utils/permissions";
import "./userRole.scss";
import AppSecureStorage from "../../services/secureStorage";

const storage = new AppSecureStorage();

export const UserRole = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const {
    page,
    limit,
    searchItem,
    sortConfig,
    searchInput,
    selectedOptionData,
  } = useSelector((state) => state.globalReducer);
  const { roles, loading, roleUsers } = useSelector((state) => state.userRoleReducer);
  const { closeBtnName, submitBtnName, isEditpopup, isEditActivate } =
    useSelector((state) => state.popUpRedducer);
  const [userData, setUserData] = useState({
    email: "",
    name: "",
    roleId: "",
  });
  const [errors, setErrors] = useState({ name: "" });
  const [addNewRole, setAddNewRole] = useState({
    name: selectedOptionData?.name || "",
    permissions: selectedOptionData?.permissions || "",
  });
  const [openRolesDelete, setOpenRolesDelete] = useState(false);

  // const [visibleColumns, setVisibleColumns] = useState({
  //   sNo: true,
  //   name: true,
  //   userCount: true,
  //   permissions: true,
  // });

  const [visibleColumns, setVisibleColumns] = useState(() => {
  // Load from localStorage on mount, fallback to default
  const saved = storage.get(`visibleColumns_${'userRole'}`); // Use title for per-table persistence
  return saved
    ? JSON.parse(saved)
    : {
        sNo: true,
        name: true,
        userCount: true,
        permissions: true,
      };
  });

  useEffect(() => {
    storage.set(`visibleColumns_${'userRole'}`, JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [viewGroupDialog, setViewGroupDialog] = useState(false);
  const [selectedRoleName, setSelectedRoleName] = useState("");

  const dataSource = useMemo(() => {
    if (!roles?.data) return [];
    return roles.data.map((item) => ({ ...item, key: item._id }));
  }, [roles?.data]);

  const handleConfirmationOpen = (record) => {
    dispatch(setCloseBtnName("Cancel"));
    dispatch(setSubmitBtnName("Next"));
    dispatch(setSelectedOption(record));
    dispatch(setPopUpTitle("User Role"));
    dispatch(setIsEditpopup(true));
    dispatch(setIsEditActive(true));
  };
  
  const actionsOptions = [
    {
      label: "View Users",
      acttion: (record) => handleViewUsers(record),
      icon: <EyeOutlined />,
    },
    {
      label: "Edit",
      acttion: (record) => {
        handleConfirmationOpen(record);
        setAddNewRole({
          ...addNewRole,
          name: record?.name,
          permissions: record?.permissions,
        });
      },
      icon: <EditOutlined />,
    },
  ];

  const handleViewUsers = (record) => {
    setSelectedRoleName(record.name);
    dispatch(getRoleUsersById({ id: record._id, navigate }))
      .unwrap()
      .then((res) => {
        // message.success("Group details loaded successfully.");
        // Set state to open the DialogBox
        setViewGroupDialog(true);
      })
      .catch((err) => {
        message.error("Failed to load Role users group details.");
      });
  }

  const handleExport = () => {
    if (!roleUsers?.users?.length) return;
    
    const headers = ["Name", "Email", "Role", "Number"];
    const rows = roleUsers?.users?.map((user) =>
      `"${user.name}","${user.email}","${user.role}","${user.whatsappContactNumber?? "-"}"`
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "role_users.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePopUpOpen = () => {
    dispatch(setCloseBtnName("Cancel"));
    dispatch(setSubmitBtnName("Next"));
    dispatch(setActionName("User Role"));
    dispatch(setPopUpTitle("User Role"));
    dispatch(setIsPopUpShow(true));
    dispatch(setIsEditpopup(false));
    dispatch(setIsEditActive(false));
  };

  const onRolesDelete = (body) => {
    dispatch(
      deleteRolesData({
        body,
        page,
        limit,
        searchQuery: searchInput || "",
        sortKey: sortConfig.key,
        sortDirection: sortConfig.direction,
        navigate,
      })
    ).then(() => {
      setOpenRolesDelete(false);
      setSelectedRowKeys([]);
    });
  };

  useEffect(() => {
    dispatch(
      getRolesData({
        page: page,
        limit: limit,
        searchQuery: searchInput || "",
        sortKey: sortConfig.key,
        sortDirection: sortConfig.direction,
        navigate: navigate,
      })
    );
  }, [page, limit, searchItem, sortConfig]);

  const handleChaneRole = (e) => {
    const { name, value } = e.target;
    setAddNewRole({ ...addNewRole, name: e.target.value });

    // Simple validation
    const regex = /^[A-Za-z_ ]+$/;
    if (value.trim() === "") {
      setErrors({ ...errors, name: "Role name is required" });
    } else if (!regex.test(value)) {
      setErrors({
        ...errors,
        [name]: "Only letters, spaces, and underscores are allowed",
      });
    } else if (value.length > 50) {
      setErrors({
        ...errors,
        name: "Name cannot exceed 50 characters",
      });
      return;
    } else {
      setErrors({ ...errors, name: "" });
    }
  };

  const handleRolesDeletion = () => {
    setOpenRolesDelete(true);
  };

  const onNext = () => {
    dispatch(getAllPermissions({ navigate: navigate }));
    const regex = /^[A-Za-z_ ]+$/;
    if (addNewRole.name.trim() === "") {
      setErrors({ ...errors, name: "Role name is required" });
      return;
    } else if (!regex.test(addNewRole.name)) {
      setErrors({
        ...errors,
        name: "Only letters, spaces, and underscores are allowed",
      });
      return;
    } else if (addNewRole.name.length > 50) {
      setErrors({
        ...errors,
        name: "Name cannot exceed 50 characters",
      });
    } else {
      dispatch(setIsActivatePopup(true));
      dispatch(setIsPopUpShow(false));
    }
  };

  const handleOk = () => {
    dispatch(setIsActivatePopup(false));
    dispatch(setIsPopUpShow(false));
    setErrors({ ...errors, name: "" });
    setAddNewRole({ ...addNewRole, name: "", permissions: {} });
    dispatch(setIsEditActive(false));
    dispatch(setIsEditpopup(false));
  };

  const goBack = () => {
    dispatch(setIsActivatePopup(false));
    dispatch(setIsPopUpShow(false));
    setErrors({ ...errors, name: "" });
  };

  const renderFooter = () => (
    <div className="button-groups">
      <Button onClick={handleOk}>{closeBtnName}</Button>
      <Button onClick={onNext}>{submitBtnName}</Button>
    </div>
  );

  const onSubmitPermission = () => {
    const filteredPermissions = Object.fromEntries(
      Object.entries(addNewRole?.permissions).filter(
        ([key, value]) => value.length > 0
      )
    );
    const updatedRole = {
      ...addNewRole,
      permissions: filteredPermissions,
    };
    if (isEditActivate) {
      dispatch(
        editRoleData({
          body: updatedRole,
          page: page,
          id: selectedOptionData?._id,
          limit: limit,
          searchQuery: searchItem || "",
          sortKey: sortConfig.key,
          sortDirection: sortConfig.direction,
          navigate: navigate,
        })
      );
      dispatch(setPage(1));
      dispatch(setLimit(10));
      dispatch(
        getRolesData({
          page,
          limit,
          searchQuery: searchItem || "",
          sortKey: sortConfig.key,
          sortDirection: sortConfig.direction,
          navigate,
        })
      );
      dispatch(getAllPermissions({ navigate: navigate }));
      setAddNewRole({ ...addNewRole, name: "", permissions: {} });
    } else {
      dispatch(
        addNewRoleData({
          body: addNewRole,
          page: page,
          limit: limit,
          searchQuery: searchItem || "",
          sortKey: sortConfig.key,
          sortDirection: sortConfig.direction,
          navigate: navigate,
        })
      ).then(() => {
        setAddNewRole({ ...addNewRole, name: "", permissions: {} });
      });
      dispatch(getAllPermissions({ navigate: navigate }));
    }
  };

  const renderPopupContent = () => {
    return (
      <div>
        <Form.Item
          required
          label="Role"
          layout="vertical"
          className="role-input-field"
        >
          <Input
            size="large"
            name="name"
            value={addNewRole?.name}
            onChange={handleChaneRole}
            placeholder="Enter user role"
            status={errors?.name ? "error" : ""}
            prefix={<UserOutlined />}
            showCount
          />
        </Form.Item>
        {errors.name && <div className="error-message">{errors.name}</div>}
      </div>
    );
  };

  const rowSelection = isUserRoleDelete
    ? {
        onChange: (selectedRowKeys, selectedRows) => {
          const filteredKeys = selectedRows
            .filter((row) => !["admin", "employee"].includes(row.name))
            .map((row) => row.key);
          setSelectedRowKeys(filteredKeys);
        },
        getCheckboxProps: (record) => ({
          disabled: ["admin", "employee"].includes(record.name),
          name: record.name,
        }),
        selectedRowKeys,
      }
    : null;

  return (
    <>
      <CommanTable
        title="User Role"
        data={dataSource}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
        apiCall={(page, limit, searchInput, sortKey, sortDirection) => {
          dispatch(
            getRolesData({
              page: page,
              limit: limit,
              searchQuery: searchInput || "",
              sortKey: sortKey || "name",
              sortDirection: sortDirection || "asc",
              navigate: navigate,
            })
          );
        }}
        showDeleteButton={
          !!selectedRowKeys.length && selectedRowKeys.length < dataSource.length
        }
        openDeletePopup={handleRolesDeletion}
        showDeleteSelection={selectedRowKeys.length > 0}
        actionsOptions={actionsOptions}
        icon={<SafetyCertificateOutlined className="icon-size text-white" />}
        openAddPopup={handlePopUpOpen}
        renderPopupContent={renderPopupContent}
        isFooter={true}
        customFooter={renderFooter}
        isEdit={isEditpopup}
        isPopUpShow={useSelector((state) => state.popUpRedducer.isPopUpShow)}
        onClose={() => {
          setErrors({ ...errors, name: "" });
          setAddNewRole({ ...addNewRole, name: "", permissions: {} });
          dispatch(setIsPopUpShow(false));
          dispatch(setIsEditpopup(false));
          dispatch(setIsEditActive(false));
        }}
        isAdd={true}
        loading={loading}
        rowSelection={rowSelection}
      />
      <Confirmation />
      <RoleDeleteConfirmation
        isOpen={openRolesDelete}
        onClose={() => setOpenRolesDelete(false)}
        onRemove={onRolesDelete}
        dataSource={dataSource}
        selectedRowKeys={selectedRowKeys}
      />
      <ActiveDeactive
        setOpen={() => {
          dispatch(setIsActivatePopup(false));
          setAddNewRole({ ...addNewRole, name: "", permissions: {} });
        }}
        onClose={handleOk}
        addNewRole={addNewRole}
        setAddNewRole={setAddNewRole}
        setUserData={setUserData}
        handleSubmit={onSubmitPermission}
        isEdit={isEdit}
        goBack={() => {
          goBack();
        }}
      />
      {/* view user */}
      <Modal
        title={`Role: ${selectedRoleName}`}
        open={viewGroupDialog}
        width={"65%"}
        onCancel={() => {
          setViewGroupDialog(false);
          setSelectedRoleName("");
        }}
        footer={[           
          <Button key="close" onClick={() => {
            setViewGroupDialog(false);
            setSelectedRoleName("");
          }}>
            Close
          </Button>          
          ,
        ]}
        styles={{
          body: {
            maxHeight: "60vh",
            overflow: "hidden",
          },
        }}
      >
        {roleUsers?.users?.length > 0 && (
          <Button
            key="export"
            style={{width: 'fit-content', position: 'absolute', left: 25, top: 20}}
            type="primary"
            // size="small"
            icon={<DownloadOutlined />}
            onClick={handleExport}
          >
            Export
          </Button>
        )}
        <Table
          columns={[
            { title: "Name", dataIndex: "name", key: "name" },
            { title: "Email", dataIndex: "email", key: "email" },
            { title: "Number", dataIndex: "whatsappContactNumber", key: "whatsappContactNumber" },
          ]}
          dataSource={
            roleUsers?.users?.map((m) => ({
              key: m._id,
              ...m,
            })) || []
          }
          pagination={false}
          scroll={{ y: "calc(60vh - 55px)" }}
        />
      </Modal>
    </>
  );
};

export default UserRole;
